import React, { Fragment } from 'react';
import {
	format,
	parseISO,
} from 'date-fns'
import Typography from '@material-ui/core/Typography';

const DateField = ({ record, source, showTime = false }) => (
	record && record[source] != null ?
		<Typography
			component="span"
			variant="body1">
			{
				showTime ? format(parseISO(record[source]), 'yyyy/MM/dd HH:mm:ss') : format(parseISO(record[source]), 'yyyy/MM/dd')
			}
		</Typography>
		: null
);

export default DateField;